import React from "react";

interface Props {
    label: string;
    value: string;
    valueClassName?: string;
}

const FuelStatsCard: React.FC<Props> = ({
    label,
    value,
    valueClassName,
}) => {
    return (
        <div className="rounded-xl border bg-white p-3">
            <div className="text-[11px] font-medium text-gray-500">
                {label}
            </div>

            <div
                className={`mt-1 text-xl font-semibold tracking-tight ${valueClassName || ""}`}
            >
                {value}
            </div>
        </div>
    );
};

export default FuelStatsCard;